const CurrentYear = () => {
    return new Date().getFullYear();
};

export default CurrentYear;